export enum OrderConfirmationStatusEnum {
  Unkown = 0,
  NotSent = 1,
  Sent = 2
}
